export default () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 113.6 113.6"
    xmlSpace="preserve"
  >
    <circle fill="none" strokeWidth="6" strokeMiterlimit="10" cx="46.5" cy="46.5" r="43.5" />
    <line
      fill="none"
      strokeWidth="6"
      strokeMiterlimit="10"
      x1="77.2"
      y1="77.2"
      x2="111.5"
      y2="111.5"
    />
  </svg>
);
